/* tslint:disable:max-line-length */
import React from 'react';
import classNames from 'classnames';
import { IconTypeProps } from '../types';

export const InstagramStoryMentionIcon = ({
  className,
  style,
  color = '#938BB7',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      style={style}
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.6568 2.34327C12.146 0.832223 10.1368 0 8 0C5.86317 0 3.85436 0.832223 2.34327 2.34327C0.832223 3.85436 0 5.86317 0 8C0 10.1371 0.832223 12.1461 2.34327 13.657C3.8542 15.1679 5.86317 16 8 16C10.137 16 12.146 15.1679 13.6568 13.657C15.1678 12.1461 16 10.1371 16 8C16 5.86317 15.1678 3.8542 13.6568 2.34327ZM13.3033 13.3035C11.8869 14.7199 10.0035 15.5 8 15.5C5.99669 15.5 4.1133 14.7199 2.69682 13.3035C1.28019 11.887 0.500037 10.0035 0.500037 8C0.500037 5.99685 1.28019 4.11346 2.69682 2.69682C4.11346 1.28019 5.99685 0.500037 8 0.500037C10.0033 0.500037 11.8867 1.28019 13.3033 2.69682C14.7198 4.1133 15.5 5.99669 15.5 8C15.5 10.0036 14.7198 11.887 13.3033 13.3035Z"
        fill={color}
      />
      <path
        d="M13.4386 3.59282C13.3516 3.48552 13.1941 3.46907 13.0869 3.55618C12.9796 3.64318 12.9633 3.80064 13.0503 3.90774C13.985 5.05993 14.4998 6.51316 14.4998 7.99999C14.4998 9.73643 13.8237 11.3688 12.5962 12.5964C11.3686 13.8239 9.73623 14.4999 7.99995 14.4999C6.39808 14.4999 4.85911 13.9123 3.66677 12.8451C3.56376 12.7529 3.40583 12.7618 3.31368 12.8646C3.22169 12.9675 3.23036 13.1256 3.33321 13.2175C4.61754 14.367 6.2748 14.9999 7.99995 14.9999C9.86974 14.9999 11.6277 14.2719 12.9497 12.9499C14.2717 11.6279 14.9999 9.86994 14.9999 7.99999C14.9999 6.39887 14.4454 4.83379 13.4386 3.59282Z"
        fill={color}
      />
      <path
        d="M1.49984 7.99999C1.49984 4.41586 4.4158 1.4999 7.99993 1.4999C9.60179 1.4999 11.1406 2.08767 12.3331 3.15489C12.4359 3.24704 12.594 3.23818 12.686 3.13536C12.7782 3.03251 12.7693 2.87443 12.6665 2.7824C11.3823 1.63299 9.72492 1.00006 7.99993 1.00006C6.13029 1.00006 4.37248 1.72818 3.0503 3.05036C1.72812 4.37251 1 6.13031 1 7.99999C1 9.60123 1.55449 11.1665 2.56124 12.4073C2.6107 12.4683 2.68273 12.4999 2.7555 12.4999C2.81089 12.4999 2.86659 12.4816 2.91296 12.4439C3.02007 12.357 3.03655 12.1995 2.9496 12.0924C2.01468 10.9402 1.49984 9.48678 1.49984 7.99999Z"
        fill={color}
      />
      <path
        d="M10.1021 3.98926H5.91542C4.85386 3.98926 3.99023 4.85293 3.99023 5.91448V10.1011C3.99023 11.1627 4.85386 12.0264 5.91542 12.0264H10.1021C11.1637 12.0264 12.0273 11.1627 12.0273 10.1011V5.91448C12.0273 4.85293 11.1637 3.98926 10.1021 3.98926ZM11.5204 10.1011C11.5204 10.8831 10.8841 11.5194 10.1021 11.5194H5.91542C5.13343 11.5194 4.49726 10.8831 4.49726 10.1011V5.91448C4.49726 5.13249 5.13347 4.49633 5.91542 4.49633H10.1021C10.8841 4.49633 11.5204 5.13253 11.5204 5.91448V10.1011Z"
        fill={color}
      />
      <path
        d="M10.256 5.45813C10.0858 5.45813 9.94727 5.59661 9.94727 5.76676C9.94727 5.93692 10.0858 6.07535 10.256 6.07535C10.4262 6.07535 10.5646 5.93692 10.5646 5.76676C10.5646 5.59661 10.4262 5.45813 10.256 5.45813Z"
        fill={color}
      />
      <path
        d="M8.0089 6.0379C6.92273 6.0379 6.03906 6.92157 6.03906 8.00774C6.03906 9.09398 6.92273 9.97773 8.0089 9.97773C9.09514 9.97773 9.97889 9.09398 9.97889 8.00774C9.97889 6.92157 9.09514 6.0379 8.0089 6.0379ZM8.0089 9.47085C7.20218 9.47085 6.5459 8.81449 6.5459 8.00774C6.5459 7.20118 7.20218 6.54501 8.0089 6.54501C8.81553 6.54501 9.47174 7.20118 9.47174 8.00774C9.47178 8.81449 8.81553 9.47085 8.0089 9.47085Z"
        fill={color}
      />
    </svg>
  );
};
